export default __webpack_public_path__ + "static/media/credit.7a6ff450.svg";